// API Configuration
// Centralized API endpoint configuration for ContentOS 3

export const API_BASE_URL = import.meta.env?.VITE_API_BASE_URL || '';

// API versioned endpoints — aligned with Django backend
export const API_ENDPOINTS = {
    // Auth endpoints (accounts app)
    auth: {
        login: '/api/v1/accounts/login/',
        loginBySms: '/api/v1/accounts/login/sms/',
        register: '/api/v1/accounts/register/',
        logout: '/api/v1/accounts/logout/',
        refresh: '/api/v1/accounts/token/refresh/',
        profile: '/api/v1/accounts/profile/',
        sendSms: '/api/v1/accounts/send-sms/',
        sendSmsForLogin: '/api/v1/accounts/send-sms/login/',
        captcha: '/api/v1/accounts/captcha/',
    },

    // Payment endpoints (accounts app)
    payment: {
        createOrder: '/api/v1/accounts/billing/orders/',
        queryOrder: (orderId) => `/api/v1/accounts/billing/orders/${orderId}/status/`,
        mockPay: '/api/v1/accounts/billing/mock-pay/',
        packagePlans: '/api/v1/accounts/packages/plans/',
        subscriptionPlans: '/api/v1/accounts/subscriptions/plans/',
        subscriptionCurrent: '/api/v1/accounts/subscriptions/current/',
    },

    wechat: {
        loginSession: '/api/v1/accounts/wechat/login-session/',
        loginStatus: '/api/v1/accounts/wechat/login-status/',
        bindPhone: '/api/v1/accounts/wechat/bind-phone/',
        mockScan: '/api/v1/accounts/wechat/mock-scan/',
    },

    // Content Generation endpoints
    content: {
        base: '/api/v1/content/',
        generateOutline: '/api/v1/content/outline/',
        generateContent: '/api/v1/content/generate/',
        generateImages: '/api/v1/content/image/',
        generateImageGrsai: '/api/v1/content/image/grsai/',
        taskStatus: (taskId) => `/api/v1/content/tasks/${taskId}/`,
        history: '/api/v1/content/tasks/',
    },

    // Skills & Templates endpoints
    skills: {
        base: '/api/v1/skills/',
        detail: (name) => `/api/v1/skills/${name}/`,
        userTemplates: '/api/v1/skills/templates/create/',
        templateDetail: (id) => `/api/v1/skills/templates/${id}/`,
        templateDelete: (id) => `/api/v1/skills/templates/${id}/delete/`,
    },

    // Formatter endpoints
    formatter: {
        xiaohongshu: '/api/v1/formatters/xiaohongshu/',
        wechat: '/api/v1/formatters/wechat/',
    },

    // Hotspot tracking endpoints
    hotspot: {
        trends: '/api/v1/hotspot/trends/',
        cached: (platform) => `/api/v1/hotspot/trends/${platform}/`,
        generate: '/api/v1/hotspot/trends/generate/',
        seoCheck: '/api/v1/hotspot/seo/check/',
    },

    // RSS subscription endpoints (under hotspot app)
    rss: {
        feeds: '/api/v1/hotspot/rss/',
        create: '/api/v1/hotspot/rss/create/',
        delete: (id) => `/api/v1/hotspot/rss/${id}/delete/`,
        refresh: '/api/v1/hotspot/rss/refresh/',
    },
};

// API request timeout (ms)
export const API_TIMEOUT = 30000;

// Polling interval (ms)
export const POLLING_INTERVAL = 3000;

// Max task age for polling (15 minutes)
export const MAX_TASK_POLL_AGE = 15 * 60 * 1000;
